import React from "react";
import ReactDOM from "react-dom";

import "./commonResource/css/bootstrap.css";
import "./commonResource/css/styles.css";

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);